import { render, staticRenderFns } from "./TableComponent.vue?vue&type=template&id=a1af0df6&scoped=true"
import script from "./TableComponent.vue?vue&type=script&lang=js"
export * from "./TableComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1af0df6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1af0df6')) {
      api.createRecord('a1af0df6', component.options)
    } else {
      api.reload('a1af0df6', component.options)
    }
    module.hot.accept("./TableComponent.vue?vue&type=template&id=a1af0df6&scoped=true", function () {
      api.rerender('a1af0df6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/entries/formComponents/TableComponent.vue"
export default component.exports